import { useState, useEffect } from 'react';

const useFollowUpSuppression = (serviceId, storagePrefix = 'hc-follow-up-suppressed') => {
  const getKey = () => (serviceId ? `${storagePrefix}-${serviceId}` : null);

  const read = () => {
    try {
      if (typeof window === 'undefined') return false;
      const key = getKey();
      return key ? window.sessionStorage.getItem(key) === '1' : false;
    } catch (e) {
      return false;
    }
  };

  const [isSuppressed, setIsSuppressed] = useState(read);

  useEffect(() => {
    setIsSuppressed(read());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceId]);

  const persist = (val) => {
    try {
      if (typeof window === 'undefined') return;
      const key = getKey();
      if (!key) return;
      if (val) window.sessionStorage.setItem(key, '1');
      else window.sessionStorage.removeItem(key);
    } catch (e) {
      // ignore
    }
  };

  const setSuppression = (val) => {
    setIsSuppressed(val);
    persist(val);
  };

  return [isSuppressed, setSuppression];
};

export default useFollowUpSuppression;
